import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Row, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TextInput from '../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import Loader from '../../components/Loader/Loader';
import './Organization.css';
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../../utils/helper";
import { failed, success } from "../../utils/Tostify";
import { assignUserToOrg, createSuperAdminUser, getRoles, getStaffs } from "../../api/User";
import { useGetStates } from "../../hooks/useGetStates";
import { genderOptions } from "../users/Constant";
import { getClinicsByOrgId } from "../../api/orgnizations";
import { formikAssignUser } from "./Constant";
import MultiSelect from "../../components/InputFields/MultiSelect";
import moment from "moment";
import DatePickerSelector from "../../components/InputFields/DatePicker";

const AssignUser = ({refetch, setShowAssignModal, orgData, assignedUserList = [], from, refetchClinic }) => {
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [RolesOption, setRolesOption] = useState([]);
  const [Countryvalue, setCountryValue] = useState();
  const [stateValue, setStateValue] = useState();
  const [clinicData, setClinicData] = useState([]);
  const { states, countryOptions } = useGetStates(Countryvalue);
  const dispatch = useDispatch();
  const assignedUsers = new Set(assignedUserList.map(item => item._id));

  const formik = useFormik({
    ...formikAssignUser,
    onSubmit: async (values) => {
      let res;
      try {
        setIsLoading(true);
        const payload = {
          orgId: values?.orgId,
          hospitalAccess: values?.hospitalAccess,
          defaultLogInClinic: values?.defaultLogInClinic,
          existingUserId: values?.existingUserId
        };
        if (values.userType === "assignToExistingUser") {
          res = await assignUserToOrg({ values: payload, dispatch, token });
        } else {
          res = await createSuperAdminUser({ values, dispatch, token });
        }
        if (res?.status == "SUCCESS") {
          if (typeof refetch === "function") {
            await refetch();
          }
          if (typeof refetchClinic === "function") {
            await refetchClinic();
          }
          setIsLoading(false);
          success(res?.message);
          formik.resetForm();
          setShowAssignModal();
          refetch();
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      formik.setFieldValue('hospitalAccess', [...formik.values.hospitalAccess, value]);
    } else {
      formik.setFieldValue('hospitalAccess', formik.values.hospitalAccess.filter((item) => item !== value));
    }
  };

  const getUsersList = async (page = 1, limit = 10, searchKey = "") => {
    let res;
    try {
      res = await getStaffs({ dispatch, token, page, limit, searchKey });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setUserList(responseData?.items.filter((item) =>
        item?.roleDetails?.some(role =>
          role.portalLayout === "Organization" && role.active
        )
      ).map((obj) => {
          return {
            label: obj?.firstName + " " + obj?.lastName,
            value: obj?._id,
            role: obj?.defaultRole?.label
          };
        }));
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  const CountrychangeHandler = e => {
    setCountryValue(e.target.value);
    formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
  };

  const stateHandler = (e) => {
    setStateValue(e.target.value);
    formik.setFieldValue('state', e.target.value);
  };

  const getClinicList = async (page = 1, limit = 10, searchKey = "") => {
    let res = "";
    try {
      setIsLoading(true);
      res = await getClinicsByOrgId({
        dispatch,
        token,
        page,
        limit,
        searchKey,
        orgId: orgData?.orgId || orgData?._id
      });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setClinicData(responseData?.items?.map((obj) => {
          return {
            label: obj?.name,
            value: obj?._id
          };
        }));
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleExistingUser = (e) => {
    formik.setFieldValue("existingUserId", e.target.value);
    formik.setFieldValue("selectUser", e.target.value);
    formik.setFieldValue("role", userList.find((val) => val?.value == e.target.value)?.role);
  };

  const getRolesList =async(page, limit, searchKey = "")=>{
    let res;
    try {
        setIsLoading(true);
        res = await getRoles({ dispatch, token, page, limit, searchKey });
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            setRolesOption(responseData.items.map((obj)=> {
              return {
                label: obj.roleName,
                value: obj?._id,
                portalLayout : obj?.portalLayout
              };
            }));
            setIsLoading(false);
        }else{
          setIsLoading(false);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  const handleRoles = (roles)=>{
    formik.setFieldValue("roles", roles);
  };

  const handleDefaultRole = (e) => {
    formik.setFieldValue("defaultRoleId", e.target.value);
    formik.setFieldValue("defaultRole", formik.values.roles?.find((obj)=> obj?.value ==  e.target.value));
  };


  //orgData?.orgId coming when user come from add user from organization
  // orgData?._id coming when user clicks Add User button in clinic
  useEffect(() => {
    if(orgData?._id){
      getClinicList();
    }
    formik.setFieldValue("orgId", orgData?.orgId || orgData?._id);
    formik.setFieldValue("defaultLogInOrg", orgData?.orgId  || orgData?._id);
  }, [orgData?.orgId, orgData?._id]);

  useEffect(() => {
    getUsersList();
    getRolesList();
    if(orgData?._id){
      formik.setFieldValue("hospitalAccess", [orgData?.clinicData?._id]);
    }
    if(from == "clinic"){
      formik.setFieldValue("userType", "assignToExistingUser");
    }
  }, []);
  useEffect(() => {
    if (setShowAssignModal) {
      const modalBody = document.querySelector('.assign_modal_body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }
  }, [setShowAssignModal]);

  return (
    <Fragment>
      <Modal isOpen={setShowAssignModal} toggle={setShowAssignModal} size="xl" className="assign_user_modal">
        <ModalHeader toggle={setShowAssignModal} className="assign_blk p-0 mb-3">Assign User</ModalHeader>
        <Form onSubmit={formik.handleSubmit}>
          <ModalBody className="assign_modal_body">
            {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_modal">
                <div className="first_block mb-4">
                <Row>
                </Row>
                {formik.values.userType === "assignToExistingUser" && <Row>
                    <Col lg={6} className="location_block mb-3">
                      <TextInput
                        keyField="selectUser"
                        formik={formik}
                        label="Select User"
                        type="select"
                        options={orgData?._id ? userList : userList.filter(item => !assignedUsers.has(item.value))}
                        value={formik.values.selectUser}
                        onChange={handleExistingUser}
                      />
                    </Col>
                    <Col lg={6} className="location_block mb-3">
                      <TextInput
                        keyField={"roles"}
                        formik={formik}
                        label="Role Type"
                        type="text"
                        placeholder="Role"
                        value={formik.values.role}
                        readOnly={true}
                      />
                    </Col>
                  </Row>}
                </div>
                {formik.values.userType === "createNewUser" && <>
                  <div className="first_block">
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"firstName"}
                          formik={formik}
                          label="First Name"
                          type="text"
                          placeholder="First Name"
                          value={formik.values.firstName}
                          onChange={(e) => formik.setFieldValue("firstName", e.target.value)}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"lastName"}
                          formik={formik}
                          label="Last Name"
                          placeholder={"Last Name"}
                          type="text"
                          value={formik.values.lastName}
                          onChange={(e) => formik.setFieldValue("lastName", e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"gender"}
                          formik={formik}
                          label="Gender"
                          type="select"
                          options={genderOptions}
                          placeholder="gender"
                          value={formik.values.gender}
                          onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <DatePickerSelector
                          keyField={"dob"}
                          formik={formik}
                          value={formik.values?.dob}
                          minDate={""}
                          maxDate={moment()}
                          label="Date Of Birth"
                          type="date"
                          onChange={(e) => formik.setFieldValue("dob", moment(e).format("MM-DD-YYYY"))}
                        />
                      </Col>
                    </Row>
                    <Row>
                  <Col lg={6} className="location_block mb-3">
                    <MultiSelect
                      keyField={"roles"}
                      formik={formik}
                      label="User Roles"
                      options={RolesOption}
                      type="select"
                      placeholder="User Roles"
                      value={formik.values.roles}
                      onChange={handleRoles}
                    />
                  </Col>
                  <Col lg={6} className="location_block mb-3">
                    <TextInput
                      keyField={"defaultRoleId"}
                      formik={formik}
                      label="Default Role"
                      type="select"
                      options={formik.values.roles}
                      value={formik.values.defaultRoleId}
                      onChange={(e) => handleDefaultRole(e)}
                    />
                  </Col>
                </Row>
                  </div>
                  <div className="first_block">
                    <h6 className="block_name">Contact Information</h6>
                    <Row>
                      <Col lg={12} className="location_block mb-3">
                        <TextInput
                          keyField={"email"}
                          formik={formik}
                          label="Email"
                          type="email"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={(e) => formik.setFieldValue("email", e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"primaryPhone"}
                          formik={formik}
                          label="Phone"
                          type="phone"
                          placeholder="Phone"
                          value={formik.values.primaryPhone}
                          onChange={(e) => formik.setFieldValue("primaryPhone", e)}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"secondaryPhone"}
                          formik={formik}
                          label="Secondary Phone"
                          required={false}
                          type="phone"
                          placeholder="Secondary Phone"
                          value={formik.values.secondaryPhone}
                          onChange={(e) => formik.setFieldValue("secondaryPhone", e)}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="first_block second_block">
                    <h6 className="block_name"> Address Information</h6>
                    <Row>
                      <Col lg={12} className="location_block mb-3">
                        <TextInput
                          keyField={"address"}
                          formik={formik}
                          label="Street"
                          type="text"
                          placeholder="Street"
                          value={formik.values.address}
                          onChange={(e) => formik.setFieldValue("address", e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"country"}
                          formik={formik}
                          options={countryOptions}
                          label="Country"
                          type="select"
                          // placeholder="Country"
                          value={Countryvalue}
                          onChange={CountrychangeHandler}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"state"}
                          formik={formik}
                          label="State"
                          options={states.map((obj) => {
                            return {
                              label: obj.name,
                              value: obj.name
                            };
                          })}
                          type="select"
                          placeholder="State"
                          value={stateValue}
                          onChange={stateHandler}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"city"}
                          formik={formik}
                          label="City"
                          type="text"
                          placeholder="City"
                          value={formik.values.city}
                          onChange={(e) => formik.setFieldValue("city", e.target.value)}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"postalCode"}
                          formik={formik}
                          label="Zip Code"
                          type="text"
                          placeholder="Zip Code"
                          value={formik.values.postalCode}
                          onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="first_block second_block">
                    <h6 className="block_name"> Employer Information</h6>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"employer"}
                          formik={formik}
                          label="Employer Name"
                          type="text"
                          placeholder="Employer Name"
                          value={formik.values.employer}
                          onChange={(e) => formik.setFieldValue("employer", e.target.value)}
                        />
                      </Col>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"department"}
                          formik={formik}
                          label="Department Name"
                          type="text"
                          placeholder="Department Name"
                          value={formik.values.department}
                          onChange={(e) => formik.setFieldValue("department", e.target.value)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="location_block mb-3">
                        <TextInput
                          keyField={"jobTitle"}
                          formik={formik}
                          label="Job Title"
                          type="text"
                          placeholder="Job Title"
                          value={formik.values.jobTitle}
                          onChange={(e) => formik.setFieldValue("jobTitle", e.target.value)}
                        />
                      </Col>
                    </Row>
                  </div>
                </>
                }
                {from == "org" && <div className="first_block user_second_block">
                  <h6 className="block_name">Access & Privileges</h6>
                  <Label className='mt-3 mb-3'>Hospital Access <span style={{color : "red", marginLeft:"3px"}}>*</span></Label>
                  <Row>
                    {clinicData.length > 0 && clinicData.map((location) => (
                      <Col lg={4} className="location_block mb-3" key={location?.value}>
                        <div className="d-flex align-items-center gap-2">
                          <Input
                            type="checkbox"
                            label={location?.label}
                            name="hospitalAccess"
                            value={location?.value}
                            onChange={handleCheckboxChange}
                          />
                          {location?.label}
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"defaultLogInClinic"}
                        formik={formik}
                        label="Default Location"
                        options={clinicData.filter((obj) => formik.values.hospitalAccess.includes(obj.value))}
                        type="select"
                        placeholder="Default Location"
                        value={formik.values.defaultLogInClinic}
                        onChange={(e) => formik.setFieldValue("defaultLogInClinic", e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>}
                {from == "clinic" && <div className="first_block user_second_block">
                  <h6 className="block_name">Access & Privileges</h6>
                  <Label className='m-0 d-flex gap-3 align-items-start mb-3 mt-3'>Hospital Access: <span>{orgData?.clinicData?.name}</span> </Label>
                  <Label className='m-0 d-flex gap-3 align-items-start mb-3 mt-3'>
                    Default Hospital:
                    <span>
                        <div className="toggle-switch">
                            <input
                                type="checkbox"
                                id="toggle"
                                onChange={(e)=> e.target.checked === true && formik.setFieldValue("defaultLogInClinic", orgData?.clinicData?._id)}
                            />
                            <label htmlFor="toggle"></label>
                        </div>
                    </span>
                  </Label>
                </div>}
            </div>
          </ModalBody>
          <ModalFooter className="p-0 mt-3">
            <div className="d-flex justify-content-between">
              <button className="save_btn" onClick={setShowAssignModal}>Close</button>
              <button className="save_btn" type="submit">Save</button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default AssignUser;
